import * as React from 'react';

import {HeaderRow} from './header-row';
import {TableRow} from './table-row';

import styles from './trial-limits-table.module.css';

type Props = {
    features: any[];
};

export function TrialLimitsTable(props: Props) {
    return (
        <div className={styles.container}>
            <HeaderRow />
            {props.features.map((feature) => (
                <TableRow feature={feature} key={feature.humanReadableType} />
            ))}
        </div>
    );
}
